import { render, staticRenderFns } from "./BulletinReadArticleComponent.vue?vue&type=template&id=65ec5451&scoped=true&"
import script from "./BulletinReadArticleComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinReadArticleComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinReadArticleComponent.vue?vue&type=style&index=0&id=65ec5451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec5451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ec5451')) {
      api.createRecord('65ec5451', component.options)
    } else {
      api.reload('65ec5451', component.options)
    }
    module.hot.accept("./BulletinReadArticleComponent.vue?vue&type=template&id=65ec5451&scoped=true&", function () {
      api.rerender('65ec5451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/bulletin/BulletinReadArticleComponent.vue"
export default component.exports